import { faFileCheck } from '@fortawesome/pro-duotone-svg-icons';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { UserType } from 'api/models';
import {
  EmptyState,
  EmptyStateContainer as EmptyStateContainerAtom,
  EmptyStateIcon,
} from 'components/atoms/empty-state';
import { NewUpdateButton } from 'components/organisms/status-updates/new-update-btn';
// import { KBLinks } from 'constant';
import { useUser } from 'hooks/use-user';

const StyledNewUpdateButton = styled(NewUpdateButton)`
  padding: 0;
`;

const EmptyStateContainer = styled(EmptyStateContainerAtom)`
  height: 100%;
`;

const Spacer = styled.div`
  margin-bottom: var(--spacing-03);
`;

export const StatusUpdatesEmptyState: FC = () => {
  const { user } = useUser();

  return user.userType === UserType.Native ||
    user.userType === UserType.Partner ? (
    <EmptyStateContainer>
      <EmptyState
        image={<EmptyStateIcon icon={faFileCheck} />}
        title={<FormattedMessage id="status_updates.empty.title" />}
        message={
          <>
            <Spacer>
              <FormattedMessage id="status_updates.empty.message" />
            </Spacer>
            <div>
              <FormattedMessage id="status_updates.empty.message.footer" />
            </div>
          </>
        }
        primaryCTA={<StyledNewUpdateButton />}
        // secondaryCTA={
        //   <EmptyState.CallToAction.Secondary
        //     href={KBLinks.statusUpdates}
        //     target="_blank"
        //   >
        //     <FormattedMessage id="status_updates.empty.secondary" />
        //   </EmptyState.CallToAction.Secondary>
        // }
      />
    </EmptyStateContainer>
  ) : (
    <EmptyStateContainer>
      <EmptyState
        image={<EmptyStateIcon icon={faFileCheck} />}
        title={<FormattedMessage id="status_updates.customer.empty.title" />}
        message={
          <FormattedMessage id="status_updates.customer.empty.message" />
        }
        // secondaryCTA={
        //   <EmptyState.CallToAction.Secondary
        //     href={KBLinks.statusUpdatesCustomer}
        //     target="_blank"
        //   >
        //     <FormattedMessage id="status_updates.customer.empty.secondary" />
        //   </EmptyState.CallToAction.Secondary>
        // }
      />
    </EmptyStateContainer>
  );
};
